const OPENERS: Record<string, string> = { ")": "(", "]": "[" };
const CLOSERS: Record<string, string> = { "(": ")", "[": "]" };
const BOOLEAN_OPERATORS = new Set(["AND", "OR", "NOT"]);

/**
 * The first structural problem in an Entrez query, in words, or null when it looks well-formed.
 *
 * NCBI is lenient: it does not reject an unbalanced query, it quietly drops the stray character and
 * runs the rest — `((semaglutide` matches everything `semaglutide` does, with a one-line warning.
 * So a query that parses is no sign it says what its author meant, and these mistakes are caught
 * here, before a count is trusted. Characters inside a quoted phrase are literal.
 */
export function findQuerySyntaxProblem(query: string): string | null {
  if (query.trim() === "") return "Enter a query.";

  const open: string[] = [];
  let inQuote = false;
  for (const char of query) {
    if (char === '"') {
      inQuote = !inQuote;
    } else if (!inQuote && char in CLOSERS) {
      open.push(char);
    } else if (!inQuote && char in OPENERS) {
      if (open.pop() !== OPENERS[char]) return `A "${char}" has no matching "${OPENERS[char]}".`;
    }
  }
  if (inQuote) return "A quotation mark is not closed.";
  const unclosed = open.pop();
  if (unclosed) return `A "${unclosed}" is not closed with a "${CLOSERS[unclosed]}".`;

  const words = query.trim().split(/\s+/);
  const last = words[words.length - 1];
  if (BOOLEAN_OPERATORS.has(last)) return `The query ends with the operator ${last}.`;
  if (BOOLEAN_OPERATORS.has(words[0]) && words[0] !== "NOT") {
    return `The query starts with the operator ${words[0]}.`;
  }
  return null;
}
